import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import {
  hasEarntLoyaltyPoints, isGuest,
} from '../../../v2/selectors/selectors';
import SocialChannelButtons from './SocialChannelButtonGroup/SocialChannelButtonGroup';
import SocialSharingReferralCode from './SocialSharingReferralCode/SocialSharingReferralCode';
import SocialSharingStatistics from './SocialSharingStatistics/SocialSharingStatistics';

const useStyles = createUseStyles({
  socialSharing: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: 400,
    width: '100%',
    margin: [0, 'auto'],
  },
  
  explanation: {
    marginTop: '1.5em',
    marginBottom: '1em',
  },
});

export const SocialSharing = (props) => {
  const classes = useStyles();
  const getSocialSharingContent = () => {
    if (props.hasReferralCode) {
      return <SocialSharingReferralCode />;
    }
    
    return <SocialSharingStatistics />;
  };
  
  return (
    <div data-test="checkoutCompleteSocialSharing">
      <div className={classes.socialSharing} data-test="SocialSharing">
        {getSocialSharingContent()}
        <SocialChannelButtons />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  hasReferralCode: (isGuest(state) && state.socialSharing.referralCode),
  loyaltyPointsUsed: hasEarntLoyaltyPoints(state),
  isNewGuestUpdatedPage: isGuest(state),
});

SocialSharing.propTypes = {
  hasReferralCode: PropTypes.bool,
  loyaltyPointsUsed: PropTypes.bool,
  isNewGuestUpdatedPage: PropTypes.bool,
};

SocialSharing.defaultProps = {
  hasReferralCode: false,
  loyaltyPointsUsed: false,
  isNewGuestUpdatedPage: false,
};

export default connect(mapStateToProps)(SocialSharing);
